// ui-settings-panel.js
import { getTier, getFeatureFlags } from '../feature-flags.js';
import { loadApp } from '../shared/ui-flow.js';
import { openPanel, closePanel } from '../shared/ui-panel-controller.js';
import { canEdit, resetApp } from '../app/auth-utils.js';
import { createProfilePanel } from './ui-settings-profile-create-panel.js';
import { editProfilePanel } from './ui-settings-profile-edit-panel.js';
import { createFoodPanel } from './ui-settings-food-create-panel.js';
import { editFoodPanel } from './ui-settings-food-edit-panel.js';
import { editNickPanel } from './ui-settings-nick-edit-panel.js';
import { createNickPanel } from './ui-settings-nick-create-panel.js';
import { createFeedbackPanel } from './ui-settings-feedback-create-panel.js';

// Elements mapped once
const panelId = 'settings';
const settingsPanel = document.getElementById('settings-panel');

// Open the panel
const openBtn = document.getElementById('open-settings-btn');
openBtn?.addEventListener('click', async () => {
  openPanel(panelId);
  await initSettingsPanel();
});
// Close the panel (back button)
const backBtn = document.querySelector('#settings-panel .back-btn');
backBtn?.addEventListener('click', () => {
  console.log('[SettingsPanel] Back to main view from settings panel');
  closePanel(panelId); // Will automatically restore previous panel (e.g. settings)
  loadApp(); // Reload app state
});

let isInitialized = false; // prevent multiple initialization

/**
 * Initialize the Settings Panel
 */
export async function initSettingsPanel() {
  if (!settingsPanel) {
    console.warn(`[SettingsPanel] Panel not found: #${panelId}`);
    return;
  }
  if (isInitialized) {
    console.log(`[SettingsPanel] Panel already initialized: #${panelId}`);
    return
  };

  // Buttons
  // Edit/New buttons
  const editProfileBtn = document.getElementById('edit-profiles-btn');
  const createProfileBtn = document.getElementById('create-profiles-btn');
  const editFoodBtn = document.getElementById('edit-foods-btn');
  const createFoodBtn = document.getElementById('create-foods-btn');
  const editNickBtn = document.getElementById('edit-nicks-btn');
  const createNickBtn = document.getElementById('create-nicks-btn');
  const createFeedbackBtn = document.getElementById('create-feedback-btn');

  const temporaryDisable = (button) => {
    button.style.backgroundColor = 'gray'; // Visually indicate disabled
    button.setAttribute('disabled', true);
  };

  // Re-enable create buttons
  const reEnableButton = (button, panel) => {
    button.style.backgroundColor = ''; // Reset background color
    button.removeAttribute('disabled');
    button?.addEventListener('click', () => {
      panel?.open(); // Now this triggers onOpen AND registers buttons
    });
  };

  // Disable buttons temporarily until feature flags are checked
  [editProfileBtn, createProfileBtn,
    editFoodBtn, createFoodBtn,
    editNickBtn, createNickBtn,
    createFeedbackBtn,
  ].forEach( (btn) => {
      temporaryDisable(btn);
    });

  document.getElementById('subscribtion').innerText = `Subscribtion type : ${getTier()}`;
  const featureFlags = await getFeatureFlags();
  console.log('[SettingsPanel] Feature flags loaded:', featureFlags);
  // Editor navigation (requires edit rights)
  if (canEdit()) {
  // Apply feature flags
    if (featureFlags["edit_members"])
      reEnableButton(editNickBtn, editNickPanel);
    if (featureFlags["new_members"])
      reEnableButton(createNickBtn, createNickPanel);
    if (featureFlags["edit_pets"])
      reEnableButton(editProfileBtn, editProfilePanel);
    if (featureFlags["new_pets"])
      reEnableButton(createProfileBtn, createProfilePanel);
    if (featureFlags["edit_foods"])
      reEnableButton(editFoodBtn, editFoodPanel);
    if (featureFlags["new_foods"])
      reEnableButton(createFoodBtn, createFoodPanel);
    reEnableButton(createFeedbackBtn, createFeedbackPanel);
  }

  // Danger zone buttons
  const resetAppBtn = document.getElementById('reset-app-btn');
  const confirmResetBtn = document.getElementById('confirm-reset-btn');
  const cancelResetBtn = document.getElementById('cancel-reset-btn');
  const resetModal = document.getElementById('reset-modal');
  // Danger zone. Reset app 
  resetAppBtn?.addEventListener('click', () => {
    resetModal?.classList.remove('hidden');
    console.log('[SettingsPanel] Reset modal opened');
  });
  cancelResetBtn?.addEventListener('click', () => {
    resetModal?.classList.add('hidden');
    console.log('[SettingsPanel] Reset modal cancelled');
  });
  confirmResetBtn?.addEventListener('click', () => {
    resetApp();
    console.log('[SettingsPanel] App state cleared, reloading...');
    location.reload();     
  });

  isInitialized = true;
}